import React from 'react';

import ClientCard from '@/components/ui/ClientCard';
import {
  CONSULTANTS,
  PRODUCTS_WITH_GUARDIAN,
} from '@/features/claimPanel/content';
import cn from '@/utils/cn';

import { useLoginContext } from '../lib/login';
import { useLingui } from '@lingui/react';

const ClientCardClaimPanel = ({ className }: { className?: string }) => {
  const { i18n } = useLingui();
  const { handleLogout, data } = useLoginContext();

  if (!data?.userData)
    return (
      <div
        className={cn(
          'mb-5 h-[136px] rounded-2xl border-primary bg-gray-100 lg:rounded-[10px] lg:border-t-[6px]',
          className
        )}
      ></div>
    );

  return (
    <ClientCard
      userData={data.userData}
      guardianTitle={i18n.t('Twój pełnomocnik')}
      guardian={CONSULTANTS.JAKUB_ASSISTANT}
      className={className}
      claimPanelVariant
      onLogoutClick={handleLogout}
      showGuardian={PRODUCTS_WITH_GUARDIAN.includes(Number(data?.productId))}
    />
  );
};

export default ClientCardClaimPanel;
